import type { Components } from '@mui/material/styles';
import { ArrowDownwardRounded } from '@mui/icons-material';

export default function MUITableSortLabel(): Components['MuiTableSortLabel'] {
  return {
    defaultProps: {
      IconComponent: ArrowDownwardRounded,
    },
    styleOverrides: {
      icon: {
        fontSize: 12,
      },
    },
  };
}
